import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles/ErrorBoundary.scss';
const ApplicationUnavailablePage = ({
  onRetry
}) => /*#__PURE__*/React.createElement("div", {
  className: styles.errorWrapper
}, /*#__PURE__*/React.createElement("div", {
  className: styles.errorContent
}, /*#__PURE__*/React.createElement("div", {
  className: styles.badge
}, "Service Unavailable"), /*#__PURE__*/React.createElement("h1", {
  className: styles.title
}, "Requested Application is currently not available."), /*#__PURE__*/React.createElement("p", {
  className: styles.description
}, "You may experience intermittent delays. We apologize for this inconvenience."), /*#__PURE__*/React.createElement("p", {
  className: styles.subtitle
}, "While we are working to correct the problem, you can:"), /*#__PURE__*/React.createElement("ul", {
  className: styles.actionList
}, /*#__PURE__*/React.createElement("li", null, "Try again by hitting the Back, Refresh or Reload buttons on your web browser"), /*#__PURE__*/React.createElement("li", null, "Try your request again later today")), /*#__PURE__*/React.createElement("p", {
  className: styles.closing
}, "Thank you"), onRetry ? /*#__PURE__*/React.createElement("button", {
  type: "button",
  className: styles.retryButton,
  onClick: onRetry
}, "Try Again") : null));
ApplicationUnavailablePage.defaultProps = {
  onRetry: null
};
export default ApplicationUnavailablePage;